export type GlobImageI = Record<string, { default: string }>

export const getImageURL = (
  glob: GlobImageI,
  filename: string,
  baseUrl: string,
  fileType: string = 'png',
): string => {
  return glob[`${baseUrl}/${filename?.toLowerCase()}.${fileType}`]?.default
}
